// src/runtimes/local/shouldContinue.tsx
var shouldContinue = (result) => result.status?.type === "requires-action" && result.status.reason === "tool-calls" && result.content.every((c) => c.type !== "tool-call" || !!c.result);
export {
  shouldContinue
};
//# sourceMappingURL=shouldContinue.mjs.map